export default {
  methods: {
    __tourListMeta(condition, totalTours, noIndex) {
      const destinationPart = (() => {
        const country = condition.primaryDestinationCountry
        const countryName = country && country.country_name_ja || ''
        const concatenatedDestinationCities = condition.destinationCities.map(c => c.city_name_ja).join('・')
        if (!countryName && !concatenatedDestinationCities) return ''

        const countryPart = condition.isMultiCountry
          ? `${countryName}ほか`
          : countryName
        return concatenatedDestinationCities
          ? `${concatenatedDestinationCities}(${countryPart})ツアー`
          : `${countryPart}ツアー`
      })()
      const departurePlacePart = condition.departurePlaceName ? `${condition.departurePlaceName}発` : ''
      const durationPart = condition.durationFrom ? ` ${condition.durationFrom}日間` : ''
      const departureMonthPart = condition.departureMonth ? `${condition.departureMonth}月出発` : ''

      const title = (() => {
        if (!condition.domesticFlagIsSpecified) return '検索結果｜海外ツアー・国内ツアーなら「旅工房」'
        if (!condition.isDomestic) return '検索結果｜海外ツアーなら「旅工房」'

        const firstDestination = condition.destinations[0]
        return firstDestination.countryId || firstDestination.cityId
          ? [
            destinationPart,
            departurePlacePart,
            durationPart,
            departureMonthPart,
            '｜の格安プランを検索・比較・予約｜国内ツアー・国内旅行なら「旅工房」',
          ].join('')
          : '国内ツアーなら「旅工房」'
      })()

      const content = (() => {
        const firstDestination = condition.destinations[0]
        if (!(condition.isDomestic && (firstDestination.countryId || firstDestination.cityId))) {
          return [
            '海外旅行・海外ツアーは「旅工房」。',
            '各国の専門知識を持ったコンシェルジュがお客様の旅をご案内、自在にアレンジします。',
            'お手頃価格のツアーもWEBで検索できます。海外旅行は旅工房におまかせ！',
          ].join('')
        }

        const detailDescription = [departurePlacePart, durationPart, departureMonthPart].filter(Boolean)
        return [
          `${destinationPart}の検索結果${totalTours.toLocaleString()}件です。`,
          ...detailDescription,
          `${detailDescription.length > 0 ? 'の' : ''}格安プランをご紹介。`,
          '専門知識を持ったコンシェルジュがお客様のツアーをご案内、自在にアレンジします。',
          'お手頃価格のツアーもWEBで検索できます。国内ツアー・国内旅行なら「旅工房」',
        ].join('')
      })()

      return {
        title,
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content,
          },
          noIndex ? { name: 'robots', content: 'noindex' } : {},
        ],
      }
    },

    __tourLpMeta(title, description, noIndex) {
      return {
        title,
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content: description,
          },
          noIndex ? { name: 'robots', content: 'noindex' } : {},
        ],
      }
    },
  },
}
